import Vue from 'vue'

window._ = require('lodash')

window.Event = new Vue()

Vue.prototype.$http = require('axios')
Vue.component('notification', require('./components/Notification.vue').default)
Vue.component('trainer-showcase', require('./components/TrainerShowcase.vue').default)
Vue.component('check-in', require('./components/Checkin.vue').default)
Vue.component('sign', require('./components/Sign.vue').default)
Vue.component('count-down', require('./components/Countdown.vue').default)

const app = new Vue({
    el: '#app',
    methods: {
        addQSParam(event) {
            let key = event.srcElement.name;
            let value = event.srcElement.value
            let url = window.location.href;
            let re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi"),
                hash;

            if (re.test(url)) {
                if (value) {
                    window.location =  url.replace(re, '$1' + key + "=" + value + '$2$3');
                }
                else {
                    hash = url.split('#');
                    url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
                    if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
                        url += '#' + hash[1];
                    }
                    window.location =  url;
                }
            }
            else {
                if (value) {
                    let separator = url.indexOf('?') !== -1 ? '&' : '?';
                    hash = url.split('#');
                    url = hash[0] + separator + key + '=' + value;
                    if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
                        url += '#' + hash[1];
                    }
                    window.location =  url;
                }
                else {
                    window.location =  url;
                }
            }
        }
    }
})

/**
 * Flatpickr setup
 */
import Flatpickr from 'flatpickr'
import { Danish } from "flatpickr/dist/l10n/da.js"
Flatpickr.localize(Danish)
Flatpickr('.has-flatpickr',{
    altInput: true,
    altFormat: 'd-m-Y',
    animate: false,
    inline: false,
    allowInput: true
})